import { HttpClient } from "@angular/common/http";
import { AbstractHttpService } from "./http-abstract.service";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { SecureFileDto, ShortUrlDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpSecureFileService extends AbstractHttpService {
	constructor(httpClient: HttpClient) {
		super(httpClient, '/api/secure-file');
	}
	public validateShortUrlCode(shortUrlCode: string): Observable<ShortUrlDto> {
		return super.doGet(`/short/${shortUrlCode}/validate-short-code`);
	}
	public validate(smsId: number, otp: string): Observable<void> {
		return super.doPost(`/${smsId}/validate-otp`, otp);
	}
	public getFileList(smsId: number, otp: string): Observable<SecureFileDto[]> {
		return super.doPost(`/${smsId}/get-file-list`, otp);
	}
	public downloadFile(smsId: number, otp: string, uuid: string): Observable<any>{
		return super.doDownloadFilePost(`/${smsId}/${uuid}/download`, otp);
	}
	public downloadAll(smsId: number, otp: string): Observable<any>{
		return super.doDownloadFilePost(`/${smsId}/download-all`, otp);
	}
}

